/**
 * Maintained by Sandon.
 */
<template>
  <div class="sy-tree" v-if="visible">
<!--    <ul>-->
<!--      <li v-for="node in flattenedNodes" :key="node.key">-->
<!--        <span class="sy-tree__indent" :style="{'width': `${(node.level - 1) * 24}px`}"></span>-->
<!--        <span v-if="!node.isLeaf">-->
<!--          <span v-if="!expandedNodeKeys[node.key]" @click="_expand(node)">+</span>-->
<!--          <span v-else @click="_collapse(node)">-</span>-->
<!--        </span>-->
<!--        <span>{{node.label}}</span>-->
<!--      </li>-->
<!--    </ul>-->
    <virtual-list
      ref="virtualList"
      class="sy-tree__nodes"
      :data-key="'key'"
      :data-sources="flattenedNodes"
      :data-component="itemComponent"
      :extra-props="{
        multiple,
        expandedNodeKeys,
        collapse: _collapse,
        expand: _expand,
        labelClick: _labelClick,
        checkboxClick: _checkboxClick,
        mustLeaf,
        focusNode: focusNode,
        selectedNodeSingle: !multiple && selectedNodes.simpleNodes.length ? selectedNodes.simpleNodes[0] : null,
        itemRender: $scopedSlots.default,
        contentWidthFull,
        progenyIndicator,
        showLine,
        mode
      }"
      :page-mode="pageMode"
      :keeps="realKeeps"/>
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import Node from './node'
import {Modes} from '../tree-model'
import coreMixin from '../tree-model/core-mixin'
export default {
  name: 'tree',
  props: {
    // 树的数据
    data: Array,
    lazy: {type: Boolean, default: false},
    load: {type: Function},
    props: Object,
    multiple: {type: Boolean, default: false},
    // 是否只有叶子节点可选
    mustLeaf: {type: Boolean, default: false},
    selectedKeys: {type: Array, default: () => []},
    // 数据联动的模式，多选时使用
    mode: {type: String, default: Modes.TWO_WAY},
    // 为true时，'down'/'separate' 模式下，如果整棵子树被选中，则只会返回子树根节点
    // change 事件：返回的 simpleNodes 中的 Node.all为 true， 如果整棵子树被选中 simpleNodes 和 simple 只会包含子树根节点
    // 初始化时：selectedKeys 中的元素， 以 {key: 'subTreeRootKey', all: true} 形式呈现
    simple: {type: Boolean, default: false},
    visible: {type: Boolean, default: true},
    // 自动展开, 值为展开路径中各节点的key组成的数组
    expandPath: {type: Array, default: () => []},
    // 判断节点是否是选中节点的祖先，即此节点是否有"小点", (Node) => Boolean
    checkAncestorFn: {type: Function, default: null},
    pageMode: {type: Boolean, default: false},
    keeps: {type: Number, default: 30},
    // 选中条目展示分隔符，表示串起来的各节点的label的分隔字符，会影响 Node.completeLabel 值
    labelDivider: {type: String, default: '/'},
    // 项的内容宽度撑开
    contentWidthFull: {type: Boolean, default: false},
    // 是否展示有选中子酸节点的指示器（小蓝点）
    progenyIndicator: {type: Boolean, default: true},
    // 线条模式
    showLine: {type: Boolean, default: false}
  },
  mixins: [coreMixin],
  components: {VirtualList},
  data () {
    return {
      flattenedNodes: [], // 打平之后的node列表
      expandedNodeKeys: {}, // 展开的node列表
      itemComponent: Node,
      focusNode: null,
      realKeeps: this._genRealKeeps()
    }
  },
  watch: {
    data: function () {
      this._genFlattenedNodes()
    },
    keeps: function () {
      this.realKeeps = this._genRealKeeps()
    }
  },
  created () {
    // console.log(this.$scopedSlots, this.$slots)
    // this.itemRender = (scope) => {
    //   if (this.$scopedSlots.default) {
    //     return this.$scopedSlots.default(scope)
    //   }
    // }
    
    this.tree.setCbs({
      appendChildrenCb: (parent) => {
        this._childrenChanged(parent)
        this._genFlattenedNodes()
      },
      expandCb: async (node) => {
        await this._expand (node)
      }
    })
    
    if (this.lazy) { // 懒加载
      if (!this.expandPath.length) {
        this._callLoad(this.root, () => { this._genFlattenedNodes() })
      } else {
        // todo 用_callLoad优化
        this.load(this.root, this._loadCb.bind(this, this.root, () => {
          this._autoExpand(this.root, 0, (node) => {
            this.$set(this.expandedNodeKeys, node.key, true)
          },
          () => {
            this._genFlattenedNodes()
          })
        }))
      }
    } else { // 全量数据
      if (this.expandPath.length) {
        let node = this.tree.getNodes([this.expandPath[0]])[0]
        while (node && node.parent) {
          this.$set(this.expandedNodeKeys, node.key, true)
          node = node.parent
        }
      }

      this._genFlattenedNodes()
    }
  },
  mounted () {
    // console.log(this.$scopedSlots, this.$slots)
    // if (this.pageMode) {
    //   window.addEventListener('scroll', () => {
    //     console.log('scroll haha')
    //     this.updatePageModeFront()
    //   }, true)
    // }
  },
  methods: {
    _genRealKeeps () {
      return this.pageMode ? Math.max(50, this.keeps) : Math.max(30, this.keeps)
    },
    // 生产 flattenedNodes
    _genFlattenedNodes () {
      const nodes = []
      this.root.childNodes.forEach(_ => this._travelTree(nodes, _))
      this.flattenedNodes = nodes
      // this.$nextTick(() => {
      //   this.$refs['virtualList'].updatePageModeFront()
      // })
    },
    // 先序遍历树
    _travelTree (nodes, node) {
      nodes.push(node)
      if (this.expandedNodeKeys[node.key]) {
        node.childNodes.forEach(_ => this._travelTree(nodes, _))
      }
    },
    // 执行展开动作 - core-mixin 依赖
    _doExpand (node) {
      this.$set(this.expandedNodeKeys, node.key, true)
      this._genFlattenedNodes()
    },
    // 收起
    _collapse (node) {
      this.$set(this.expandedNodeKeys, node.key, false)
      this._genFlattenedNodes()
    },
    // 文本被点击
    _labelClick (node) {
      this.focusNode = node

      if (this.multiple 
        || (this.mustLeaf && !node.isLeaf)) {
        this._expand(node) // 展开
        return
      }

      if (node.disabled) return

      if (!this.multiple) {
        this._updateSelectedNodesSingle(node, false, () => {
          this.$emit('close')
        }, true)
      }
    },
    // 对外接口 - 设置 checkedKeys
    setCheckedKeys (keys, force = false, halfCheckedKeys = []) {
      this.tree.setCheckedKeys(keys, force, halfCheckedKeys)
      this._updateSelectedNodesMultiple()
    },
    // 对外接口 - 透传 vue-virtual-scroll-list 的方法
    // When using page mode and virtual list root element offsetTop or offsetLeft change, you need call this method manually.
    updatePageModeFront () {
      this.$refs.virtualList.updatePageModeFront()
    }
  }
}
</script>

<style scoped lang="scss">
  .sy-tree__nodes{
    height: 100%;
    overflow-y: auto;
  }
</style>
